import { useEffect } from 'react';
import { trackSurveyShown, type SurveySurface } from './survey';
import { claimSurveyShown } from './surveyShownGuard';

// Emite `survey_shown` UNA sola vez por (comercio, encuesta) cuando un anuncio CON opciones se
// monta y queda activo. El claim atómico en localStorage (claimSurveyShown) garantiza el "1 sola
// vez" aunque el anuncio se remonte en cada navegación. Fire-and-forget: no bloquea el render.
//
// `active` permite al caller condicionar la emisión (p.ej. solo cuando el modal está abierto y
// el anuncio tiene opciones). Si es false, no emite.
export const useSurveyShownOnce = (
  announcementUuid: string | null | undefined,
  surface: SurveySurface,
  active = true,
): void => {
  useEffect(() => {
    if (!active || !announcementUuid) return;
    if (claimSurveyShown(announcementUuid)) {
      trackSurveyShown({ announcementUuid, surface });
    }
  }, [announcementUuid, surface, active]);
};
